import React from 'react';
import { Outlet } from 'react-router-dom';
import TopNavbarAuth from '../components/NavbarAuth';

export default function AuthLayoutAfter1SignIn() {
  // w-100 to fluid
  return (
    <>
      <TopNavbarAuth />
      <div className="content fluid">
        <Outlet />
      </div>
    </>
  );
}